import React, { useState, useEffect } from 'react';

const Gallery = () => {
    const [categoryView, setCategoryView] = useState(null); // For showing category items
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxData, setLightboxData] = useState({});

    // Gallery data with organized images in category folders
    const galleryData = [
        {
            id: 1,
            title: "Creative Design Project",
            category: "creative",
            image: "/logos/creative/Creative.jpg",
            description: "Innovative creative design solutions"
        },
        {
            id: 2,
            title: "Professional Logo Design",
            category: "logo",
            image: "/logos/logo/aura.png",
            description: "Clean and modern logo design solution"
        },
        {
            id: 13,
            title: "ZenV Logo Design",
            category: "logo",
            image: "/logos/logo/ZenV.png",
            description: "Modern and minimalist logo design for ZenV brand"
        },
        {
            id: 14,
            title: "BIC Logo Design",
            category: "logo",
            image: "/logos/logo/BIC.png",
            description: "Professional logo design for BIC company"
        },
        {
            id: 3,
            title: "Poster Design Project",
            category: "poster",
            image: "/logos/poster/poster.png",
            description: "Eye-catching poster design with visual impact"
        },
        {
            id: 15,
            title: "GlowFest Event Poster",
            category: "poster",
            image: "/logos/poster/GlowFest.png",
            description: "Vibrant event poster design for GlowFest"
        },
        {
            id: 16,
            title: "Batman Themed Poster",
            category: "poster",
            image: "/logos/poster/batman.png",
            description: "Creative Batman-inspired poster design"
        },
        {
            id: 17,
            title: "Christmas YRC Poster",
            category: "poster",
            image: "/logos/poster/Christmas yrc.png",
            description: "Festive Christmas event poster"
        },
        {
            id: 18,
            title: "Diwali Festival Poster",
            category: "poster",
            image: "/logos/poster/Diwali Final.png",
            description: "Colorful Diwali celebration poster"
        },
        {
            id: 19,
            title: "Ikshana Event Poster",
            category: "poster",
            image: "/logos/poster/Ikshana.png",
            description: "Professional event poster for Ikshana"
        },
        {
            id: 20,
            title: "Republic Day Poster",
            category: "poster",
            image: "/logos/poster/Republic day.png",
            description: "Patriotic Republic Day poster design"
        },
        {
            id: 21,
            title: "Texplore Event Poster",
            category: "poster",
            image: "/logos/poster/texplore.png",
            description: "Tech event poster for Texplore"
        },
        {
            id: 23,
            title: "Thulir Event Poster",
            category: "poster",
            image: "/logos/poster/Thulir.png",
            description: "Cultural event poster design"
        },
        {
            id: 24,
            title: "Uiphoria Design Poster",
            category: "poster",
            image: "/logos/poster/uiphoria 2.png",
            description: "UI/UX event poster for Uiphoria"
        },
        {
            id: 25,
            title: "Winter Event Poster",
            category: "poster",
            image: "/logos/poster/winter.png",
            description: "Seasonal winter event poster"
        },
        {
            id: 34,
            title: "World Peace Day Poster",
            category: "poster",
            image: "/logos/poster/World Peace and Understanding Day.png",
            description: "Inspiring World Peace and Understanding Day poster"
        },
        {
            id: 35,
            title: "1 Day to Go Poster",
            category: "poster",
            image: "/logos/poster/1day to go.png",
            description: "Event countdown announcement poster"
        },
        {
            id: 36,
            title: "Artboard Design Poster",
            category: "poster",
            image: "/logos/poster/Artboard 1.png",
            description: "Creative artboard design concept"
        },
        {
            id: 37,
            title: "AuraForm Studio Poster",
            category: "poster",
            image: "/logos/poster/AuraForm Studio1.png",
            description: "Studio promotional poster design"
        },
        {
            id: 38,
            title: "Cuteboy's Collection Poster",
            category: "poster",
            image: "/logos/poster/CUTEBOY'S COLLECTION.png",
            description: "Fashion collection promotional poster"
        },
        {
            id: 39,
            title: "Designer of Our Flag Poster",
            category: "poster",
            image: "/logos/poster/Designer of our flag.png",
            description: "Patriotic designer tribute poster"
        },
        {
            id: 40,
            title: "Devs Event Poster",
            category: "poster",
            image: "/logos/poster/DEvs.png",
            description: "Developer event promotional poster"
        },
        {
            id: 41,
            title: "Du Diwali Poster",
            category: "poster",
            image: "/logos/poster/Du diwali.png",
            description: "Diwali celebration event poster"
        },
        {
            id: 42,
            title: "Final Call Poster",
            category: "poster",
            image: "/logos/poster/Final Call.png",
            description: "Last call event announcement poster"
        },
        {
            id: 43,
            title: "Guess Who Poster",
            category: "poster",
            image: "/logos/poster/guess who.png",
            description: "Interactive guessing game poster"
        },
        {
            id: 44,
            title: "Promotion Poster",
            category: "poster",
            image: "/logos/poster/Promotion.png",
            description: "Brand promotion campaign poster"
        },
        {
            id: 45,
            title: "RB Event Poster",
            category: "poster",
            image: "/logos/poster/RB.png",
            description: "RB event promotional poster"
        },
        {
            id: 46,
            title: "Recharge FF Poster",
            category: "poster",
            image: "/logos/poster/Recharge ff.png",
            description: "Gaming recharge promotional poster"
        },
        {
            id: 47,
            title: "Recharge Poster",
            category: "poster",
            image: "/logos/poster/Recharge.png",
            description: "Mobile recharge service poster"
        },
        {
            id: 48,
            title: "SP Final Poster",
            category: "poster",
            image: "/logos/poster/SP Final.png",
            description: "Sports final match poster"
        },
        {
            id: 49,
            title: "Texplore 2025 Poster",
            category: "poster",
            image: "/logos/poster/Texplore_20250907_120735_0000.png",
            description: "Tech exploration event 2025 poster"
        },
        {
            id: 26,
            title: "Workshop Poster 1",
            category: "poster",
            image: "/logos/poster/ws1.png",
            description: "Professional workshop promotional poster"
        },
        {
            id: 27,
            title: "Workshop Poster 2",
            category: "poster",
            image: "/logos/poster/ws2.png",
            description: "Educational workshop poster design"
        },
        {
            id: 28,
            title: "SIH Event Poster",
            category: "poster",
            image: "/logos/poster/sih.png",
            description: "Smart India Hackathon poster design"
        },
        {
            id: 29,
            title: "Quiz Competition Poster",
            category: "poster",
            image: "/logos/poster/quiz.png",
            description: "Engaging quiz competition poster"
        },
        {
            id: 30,
            title: "Life at REC Poster",
            category: "poster",
            image: "/logos/poster/life at rec.png",
            description: "Campus life promotional poster"
        },
        {
            id: 4,
            title: "AI-Generated Design",
            category: "ai-design",
            image: "/logos/ai-design/af.png",
            description: "Cutting-edge AI-powered design solutions"
        },
        {
            id: 5,
            title: "Photo Collage Artwork",
            category: "collage",
            image: "/logos/collage/collage.png",
            description: "Creative photo arrangements and compositions"
        },
        {
            id: 6,
            title: "Greeting Card Design",
            category: "greeting",
            image: "/logos/greeting/greeting-card.png",
            description: "Personalized greeting cards for special occasions"
        },
        {
            id: 7,
            title: "Wedding Invitation",
            category: "invitation",
            image: "/logos/invitation/invitation.png",
            description: "Elegant wedding invitation design"
        },
        {
            id: 8,
            title: "Business Card Design",
            category: "business",
            image: "/logos/business/business.png",
            description: "Professional business card with modern aesthetics"
        },
        {
            id: 9,
            title: "Creative Strategy Project",
            category: "consulting",
            image: "/logos/consulting/Creative.jpg",
            description: "Strategic creative consulting and concept development"
        },
        {
            id: 10,
            title: "Video Editing Project",
            category: "video",
            image: "/logos/video/Video.mov",
            isVideo: true,
            description: "Professional video editing with motion graphics"
        },
        {
            id: 31,
            title: "Thalaiva Video Edit",
            category: "video",
            image: "/logos/video/thalaiva.mov",
            isVideo: true,
            description: "Creative video editing for Thalaiva tribute"
        },
        {
            id: 32,
            title: "Soon - Coming Soon Video",
            category: "video",
            image: "/logos/video/Soon.mp4",
            isVideo: true,
            description: "Teaser video with coming soon announcement"
        },
        {
            id: 11,
            title: "2D Animation",
            category: "animation",
            image: "/logos/animation/Animation.mp4",
            isVideo: true,
            description: "Dynamic 2D animation and motion graphics"
        },
        {
            id: 33,
            title: "RJR Animation",
            category: "animation",
            image: "/logos/animation/RJR.mp4",
            isVideo: true,
            description: "Custom 2D animation project for RJR"
        },
        {
            id: 12,
            title: "Frontend Development",
            category: "frontend",
            image: "/logos/frontend/web-portal.jpg",
            description: "Modern React-based frontend development"
        }
    ];

    // Category preview data
    const categoryPreviews = {
        all: {
            image: "/logos/creative/Creative.jpg",
            title: "All Categories",
            description: "Browse our complete portfolio showcasing diverse design projects",
            count: 12
        }
    };

    const openCategoryView = (category) => {
        setCategoryView(category);
    };

    const closeCategoryView = () => {
        setCategoryView(null);
    };

    const openLightbox = (item) => {
        setLightboxData(item);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };

    // Get unique categories and show only one item per category for main gallery
    const getUniqueCategoryItems = () => {
        const seenCategories = new Set();
        return galleryData.filter(item => {
            if (seenCategories.has(item.category)) {
                return false;
            }
            seenCategories.add(item.category);
            return true;
        });
    };

    const displayItems = getUniqueCategoryItems();

    const currentPreview = categoryPreviews.all;

    useEffect(() => {
        const handleEscKey = (e) => {
            if (e.key === 'Escape') {
                if (lightboxOpen) {
                    closeLightbox();
                } else if (categoryView) {
                    closeCategoryView();
                }
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => document.removeEventListener('keydown', handleEscKey);
    }, [lightboxOpen, categoryView]);

    return (
        <>
            {/* Page Header */}
            <section className="page-header">
                <div className="container">
                    <div className="header-content">
                        <h1 className="page-title">Our Portfolio</h1>
                        <p className="page-subtitle">Explore our collection of creative works</p>
                        <div className="breadcrumb">
                            <a href="/home">Home</a> <span>/</span> <span>Gallery</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Gallery Section */}
            <section className="gallery">
                <div className="container">

                    {/* Category Preview Section */}
                    <div className="category-preview">
                        <div className="preview-content">
                            <div className="preview-image">
                                {(currentPreview.image.endsWith('.mov') || currentPreview.image.endsWith('.mp4')) ? (
                                    <video
                                        src={currentPreview.image}
                                        className="preview-video"
                                        muted
                                        loop
                                        autoPlay
                                        playsInline
                                        preload="auto"
                                        onError={(e) => {
                                            console.log('Preview video failed to load:', e.target.src);
                                            e.target.style.display = 'none';
                                            const img = document.createElement('img');
                                            img.src = `https://via.placeholder.com/200x150/1a1a1a/00bfff?text=${encodeURIComponent(currentPreview.title)}`;
                                            e.target.parentNode.insertBefore(img, e.target);
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={currentPreview.image}
                                        alt={currentPreview.title}
                                        onError={(e) => {
                                            e.target.src = `https://via.placeholder.com/200x150/1a1a1a/00bfff?text=${encodeURIComponent(currentPreview.title)}`;
                                        }}
                                    />
                                )}
                            </div>
                            <div className="preview-info">
                                <h3>{currentPreview.title}</h3>
                                <p>{currentPreview.description}</p>
                                <div className="preview-stats">
                                    <span className="stat-item">
                                        <i className="fas fa-images"></i>
                                        <span>{currentPreview.count} Project{currentPreview.count > 1 ? 's' : ''}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="gallery-grid">
                        {displayItems.map(item => (
                            <div
                                key={item.id}
                                className="gallery-item"
                                data-category={item.category}
                                onClick={() => openCategoryView(item.category)}
                            >
                                {item.isVideo ? (
                                    <video
                                        src={item.image}
                                        className="gallery-img gallery-video"
                                        muted
                                        loop
                                        autoPlay
                                        playsInline
                                        preload="auto"
                                        onError={(e) => {
                                            console.log('Video failed to load:', e.target.src);
                                            e.target.style.display = 'none';
                                            const img = document.createElement('img');
                                            img.src = `https://via.placeholder.com/400x300/1a1a1a/00bfff?text=${encodeURIComponent(item.title)}`;
                                            img.className = 'gallery-img';
                                            e.target.parentNode.insertBefore(img, e.target);
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="gallery-img"
                                        onError={(e) => {
                                            e.target.src = `https://via.placeholder.com/400x300/1a1a1a/00bfff?text=${encodeURIComponent(item.title)}`;
                                        }}
                                    />
                                )}
                                <div className="gallery-overlay">
                                    <div className="gallery-info">
                                        <h3 className="gallery-title">{item.title}</h3>
                                        <p className="gallery-category">{item.category.toUpperCase()}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Featured Projects Section */}
            <section className="featured-projects">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Featured Projects</h2>
                        <p className="section-subtitle">Highlights from our recent work</p>
                    </div>
                    <div className="featured-grid">
                        <div className="featured-project">
                            <div className="project-image">
                                <img src="/logos/creative/Creative.jpg" alt="Creative Design Project" />
                                <div className="project-overlay">
                                    <div className="project-info">
                                        <h3>Creative Design Project</h3>
                                        <p>Innovative creative design solutions for digital media</p>
                                        <div className="project-tags">
                                            <span>Creative Design</span>
                                            <span>Digital Art</span>
                                            <span>Visual Identity</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="featured-project">
                            <div className="project-image">
                                <img src="/logos/poster/poster.png" alt="Event Poster Design" />
                                <div className="project-overlay">
                                    <div className="project-info">
                                        <h3>Event Poster Design</h3>
                                        <p>Creative poster design for music festival</p>
                                        <div className="project-tags">
                                            <span>Poster Design</span>
                                            <span>Event Marketing</span>
                                            <span>Creative</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="featured-project">
                            <div className="project-image">
                                <img src="/logos/auraform.png" alt="Professional Logo Design" />
                                <div className="project-overlay">
                                    <div className="project-info">
                                        <h3>Professional Logo Design</h3>
                                        <p>Clean and modern logo design solution</p>
                                        <div className="project-tags">
                                            <span>Logo Design</span>
                                            <span>Visual Identity</span>
                                            <span>Creative</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Client Testimonials */}
            <section className="testimonials">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Client Testimonials</h2>
                        <p className="section-subtitle">What our clients say about our work</p>
                    </div>
                    <div className="testimonials-grid">
                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <div className="quote-icon">
                                    <i className="fas fa-quote-left"></i>
                                </div>
                                <p>"AuraForm Studio-oda design work romba nalla irunthuchu! Enga company-ku oru perfect logo design pannaanga. Very satisfied!"</p>
                                <div className="client-info">
                                    <div className="client-avatar">
                                        <i className="fas fa-user-circle"></i>
                                    </div>
                                    <div className="client-details">
                                        <h4>Karthik Raman</h4>
                                        <span>Business Owner, Chennai</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <div className="quote-icon">
                                    <i className="fas fa-quote-left"></i>
                                </div>
                                <p>"Enoda wedding invitation card design panradhu ku AuraForm-a approach panninen. Avanga work quality super! Friends ellam praise pannanga."</p>
                                <div className="client-info">
                                    <div className="client-avatar">
                                        <i className="fas fa-user-circle"></i>
                                    </div>
                                    <div className="client-details">
                                        <h4>Priya Sankaran</h4>
                                        <span>Teacher, Coimbatore</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <div className="quote-icon">
                                    <i className="fas fa-quote-left"></i>
                                </div>
                                <p>"Enga small business-ku poster design vennum-nu sollinen. AuraForm team romba creative-a pannaanga. Price-um reasonable!"</p>
                                <div className="client-info">
                                    <div className="client-avatar">
                                        <i className="fas fa-user-circle"></i>
                                    </div>
                                    <div className="client-details">
                                        <h4>Murugan Selvam</h4>
                                        <span>Shop Owner, Madurai</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Start Your Next Project?</h2>
                        <p>Join our satisfied clients and transform your vision into reality.</p>
                        <a href="/contact" className="cta-button">
                            <span className="btn-text">Get Started</span>
                            <div className="btn-glow"></div>
                        </a>
                    </div>
                </div>
            </section>

            {/* Category View Modal */}
            {categoryView && (
                <div className="lightbox" onClick={closeCategoryView}>
                    <div className="lightbox-content category-view-content" onClick={(e) => e.stopPropagation()}>
                        <span className="lightbox-close" onClick={closeCategoryView}>&times;</span>
                        <div className="category-view-header">
                            <h2>{categoryView.toUpperCase()} Projects</h2>
                            <p>Click on any image to view details</p>
                        </div>
                        <div className="category-view-grid">
                            {galleryData
                                .filter(item => item.category === categoryView)
                                .map(item => (
                                    <div
                                        key={item.id}
                                        className="category-view-item"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openLightbox(item);
                                        }}
                                    >
                                        {item.isVideo ? (
                                            <video
                                                src={item.image}
                                                className="category-view-img"
                                                muted
                                                loop
                                                autoPlay
                                                playsInline
                                                preload="auto"
                                                onError={(e) => {
                                                    console.log('Category view video failed to load:', e.target.src);
                                                    e.target.style.display = 'none';
                                                    const img = document.createElement('img');
                                                    img.src = `https://via.placeholder.com/400x300/1a1a1a/00bfff?text=${encodeURIComponent(item.title)}`;
                                                    img.className = 'category-view-img';
                                                    e.target.parentNode.insertBefore(img, e.target);
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="category-view-img"
                                                onError={(e) => {
                                                    e.target.src = `https://via.placeholder.com/400x300/1a1a1a/00bfff?text=${encodeURIComponent(item.title)}`;
                                                }}
                                            />
                                        )}
                                        <div className="category-view-overlay">
                                            <div className="category-view-info">
                                                <h3>{item.title}</h3>
                                                <p>Click to view details</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Lightbox Modal */}
            {lightboxOpen && (
                <div className="lightbox" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <span className="lightbox-close" onClick={closeLightbox}>&times;</span>
                        {lightboxData.isVideo ? (
                            <video
                                src={lightboxData.image}
                                className="lightbox-video"
                                controls
                                autoPlay
                                muted
                                loop
                                playsInline
                                onError={(e) => {
                                    console.log('Lightbox video failed to load:', e.target.src);
                                }}
                            />
                        ) : (
                            <img
                                src={lightboxData.image}
                                alt={lightboxData.title}
                                className="lightbox-img"
                                onError={(e) => {
                                    e.target.src = `https://via.placeholder.com/800x600/1a1a1a/00bfff?text=${encodeURIComponent(lightboxData.title)}`;
                                }}
                            />
                        )}
                        <div className="lightbox-info">
                            <h3>{lightboxData.title}</h3>
                            <p>{lightboxData.description}</p>
                            <div className="lightbox-category">
                                <span>{lightboxData.category?.toUpperCase()}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Gallery;
